// extracted by mini-css-extract-plugin
export default {"productImage":"ProductEdit_productImage__cPS+y"};